module.exports = __webpack_public_path__ + "static/img/img-background-3.eb6ee5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/carousel_background/img-background-3.jpg
// module id = 3nFi
// module chunks = 36